import t from"./getUiOptions.esm.js";function e(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return"widget"in t(e)&&"hidden"!==t(e).widget}export{e as default};
